/**
 * Created by linjianxi on 2016/10/27.
 */
import * as types from './mutation-type'
import * as http from '../../../utils/common'
/**
 * 更新设置转态
 * @param commit
 * @param params
 */
export const checkSwitch = ({ commit }, params) => {
  http.post({
    url: '/api/FundHqb/SetAutoRechargeStautus',
    data: {Status: params.type},
    succ: function (res) {
      let isActive = document.querySelector('#mySwitch').classList.contains('mui-active')
      if (isActive) {
        document.querySelector('#mySwitch').classList.remove('mui-active')
        console.log(' 打开状态 ')
      } else {
        document.querySelector('#mySwitch').classList.add('mui-active')
        console.log(' 关闭状态 ')
      }
      commit(types.CHECKSWITCH, res.data)
    }
  }, params._this.$store.commit)
}
/**
 * 获取设置转态
 * @param commit
 * @param params
 */
export const getRechargeStatu = ({commit}, params) => {
  http.post({
    url: '/api/FundHqb/GetAutoRechargeStautus',
    data: {},
    succ: function (res) {
      if (res.result === 1) {
        console.log(res)
        commit(types.GET_RECHARGE_STATUS, res.data)
      } else {
        mui.alert(res.message)
      }
    }
  }, params._this.$store.commit)
}




// WEBPACK FOOTER //
// ./src/vuex/modules/setting/ations.js